import { render, staticRenderFns } from "./exportExc.vue?vue&type=template&id=62fe31f0&scoped=true"
import script from "./exportExc.vue?vue&type=script&lang=js"
export * from "./exportExc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fe31f0",
  null
  
)

export default component.exports